<template>
    <div v-if="!$store.state.user">
        <h1 class="d-flex align-center">
            <div class="flex-grow-1 hidden-sm-and-down">{{ $translate('Player pool') }}</div>
        </h1>
        {{ $translate('In order to see the Player pool you need to be logged in') }}
    </div>
    <div v-else>
        <h1 class="d-flex align-center">
            <div class="flex-grow-1 hidden-sm-and-down">{{ $translate('Player pool') }}</div>
            <v-btn large color="primary" @click="searchTeam" class="mr-4" :class="{'flex-grow-1': $vuetify.breakpoint.smAndDown}">
                {{ $translate('Search team') }}
            </v-btn>
            <v-btn large color="primary" @click="searchPlayer" :class="{'flex-grow-1': $vuetify.breakpoint.smAndDown}" v-if="myGroups.length > 0">
                {{ $translate('Search player') }}
            </v-btn>
        </h1>

        <v-row class="mt-6">
            <v-col cols="12" md="6" v-for="teamApplication in teamApplications" :key="teamApplication.id">
                <TeamsportPlayerPoolRecruitmentCard :application="teamApplication" :groups="myGroups" />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="6">
                <TeamsportPlayerPoolPlayersLookingForTeamsCard :teamsports="teamsports" :posts="userPosts" :groups="myGroups" />
            </v-col>
            <v-col cols="12" md="6">
                <TeamsportPlayerPoolTeamsLookingForPlayersCard :teamsports="teamsports" :posts="teamPosts" />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="6">
                <TeamsportPlayerPoolMyPosts :teamsports="teamsports" :posts="myPosts" />
            </v-col>
        </v-row>

        <TeamsportPlayerPoolUserPostDialog
            v-model="searchTeamDialog"
            :teamsports="teamsports"
            :add="true"
            v-if="searchTeamDialog"
        />

        <TeamsportPlayerPoolTeamPostDialog
            v-model="searchPlayerDialog"
            :groups="myGroups"
            :add="true"
            v-if="searchPlayerDialog"
        />
    </div>
</template>

<script>
import TeamsportPlayerPoolRecruitmentCard from './TeamsportPlayerPoolRecruitmentCard.vue'
import TeamsportPlayerPoolPlayersLookingForTeamsCard from './TeamsportPlayerPoolPlayersLookingForTeamsCard.vue'
import TeamsportPlayerPoolTeamsLookingForPlayersCard from './TeamsportPlayerPoolTeamsLookingForPlayersCard.vue'
import TeamsportPlayerPoolMyPosts from './TeamsportPlayerPoolMyPosts.vue'
import TeamsportPlayerPoolUserPostDialog from './TeamsportPlayerPoolUserPostDialog.vue'
import TeamsportPlayerPoolTeamPostDialog from './TeamsportPlayerPoolTeamPostDialog.vue'
export default {
    name: 'zoezi-teamsport-player-pool',

    zoezi: {
        title: 'Player pool',
        icon: 'mdi-table-large',
        addon: 'PlayerPool'
    },

    components: {
        TeamsportPlayerPoolRecruitmentCard,
        TeamsportPlayerPoolPlayersLookingForTeamsCard,
        TeamsportPlayerPoolTeamsLookingForPlayersCard,
        TeamsportPlayerPoolMyPosts,
        TeamsportPlayerPoolUserPostDialog,
        TeamsportPlayerPoolTeamPostDialog
    },

    watch: {
        '$store.state.user'() {
            this.getData();
        }
    },

    data: () => ({
        teamsports: [],
        teamPosts: [],
        userPosts: [],
        myGroups: [],
        applications: [],
        unsubscribe: [],
        searchTeamDialog: false,
        searchPlayerDialog: false
    }),

    computed: {
        teamApplications() {
            let myGroupsPosts = this.teamPosts.filter(post => this.myGroups.find(group => group.id === post.group.id));
            return myGroupsPosts.map(post => {
                return {
                    id: post.id,
                    group: this.myGroups.find(group => group.id == post.group.id),
                    comment: post.comment,
                    posts: this.applications.filter(application => application.playerPoolTeam_id == post.id)
                }
            });
        },
        myPosts() {
            return this.userPosts.filter(post => post.user_id === this.$store.state.user.id);
        }
    },

    methods: {
        getTeamsports() {
            this.loading = true;
            this.$api.get('/api/teamsport/get').then((teamsports) => {
                this.teamsports = teamsports.sort((a, b) => a.name.localeCompare(b.name));
                this.loading = false;
            })
        },
        searchTeam() {
            this.searchTeamDialog = true;
        },
        searchPlayer() {
            this.searchPlayerDialog = true;
        },
        getAllPlayerPoolRequests() {
            this.$api.get('/api/playerpoolteam/get_with_request_status').then(posts => {
                this.teamPosts = posts
            });
        },
        getAllPlayerPoolUsers() {
            this.$api.get('/api/playerpooluser/get').then(posts => {
                this.userPosts = posts
            });
        },
        getPendingApplications() {
            this.applications = [];
            this.$api.get('/api/memberapi/usergroup/get_responsible_for').then(groups => {
                this.myGroups = groups;
                groups.forEach(group => {
                    this.$api.get('/api/playerpool/request/get', { group_id: group.id }).then(requests => {
                        this.applications.push(...requests);
                    });
                });
            });
        },
        getData() {
            if (!this.$store.state.user) {
                return;
            }
            this.getPendingApplications();
            this.getAllPlayerPoolRequests();
            this.getAllPlayerPoolUsers();
        }
    },
    destroyed() {
        this.unsubscribe.forEach(u => u?.());
    },
    mounted() {
        this.getTeamsports();
        this.getData();

        this.unsubscribe.push(this.$api.subscribe({type: 'playerpoolteam', callback: () => {
            this.getData();
        }}));

        this.unsubscribe.push(this.$api.subscribe({type: 'playerpooluser', callback: () => {
            this.getData();
        }}));

        this.unsubscribe.push(this.$api.subscribe({type: 'usergrouprequest', callback: () => {
            this.getData();
        }}));
    }
}
</script>
